(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/new-game-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/new-game-item.js');
'use strict';

const Brand = svs.ui.ReactBrand;
const ErrorBoundary = svs.components.errorBoundary.ErrorBoundary;

const NewGameItem = _ref => {
  var _product$informativeT;
  let product = _ref.product,
    teamId = _ref.teamId;
  const navigateToProduct = () => {
    svs.utils.url.navigate("".concat(product.urlMapping, "?syndicateId=").concat(teamId).concat(product.query || ''));
  };
  const goToProduct = e => {
    e.preventDefault();
    const track = {
      category: 'spela-tillsammans',
      action: 'play_new_game',
      opt_label: product.productName || 'Undefined product'
    };
    svs.components.analytics.trackEvent(track, navigateToProduct);
  };
  return React.createElement("div", {
    className: "list-group-item list-group-item-link ms-hover-tur-100",
    style: {
      border: 'none'
    }
  }, React.createElement("a", {
    onClick: goToProduct
  }, React.createElement("div", {
    className: "u-flex"
  }, React.createElement("div", null, React.createElement(ErrorBoundary, null, React.createElement(Brand, {
    brand: product.branding,
    size: 200,
    square: true
  }))), React.createElement("div", {
    className: "padding-xs-left-1 padding-top"
  }, React.createElement("div", {
    className: "f-bold"
  }, product === null || product === void 0 || (_product$informativeT = product.informativeTexts) === null || _product$informativeT === void 0 ? void 0 : _product$informativeT.map(text => React.createElement("div", {
    key: text
  }, text))), React.createElement("span", null, product === null || product === void 0 ? void 0 : product.drawDays)))));
};
svs.arena.pages.teams.components.NewGameItem = NewGameItem;

 })(window);